export enum VppsAPIRoutes {
    GET_VPPS = "panelvideos:videos:query",
    GET_VPPS_USERS = "auth:users:query",
    CREATE_VPP = "panelvideos:videos:create",
    GET_SUBSIDIARIES = "subsidiary:query",
    DELETE_VPP = "panelvideos:videos:delete"
}
